/**
 * Detect if the current browser is an in-app WebView
 * (WhatsApp, Facebook, Instagram, Telegram, etc.)
 * Google blocks OAuth from these browsers (Error 403: disallowed_useragent)
 */
export function isInAppBrowser() {
  const ua = navigator.userAgent || '';
  const inAppPatterns = [
    'FBAN', 'FBAV',           // Facebook
    'Instagram',              // Instagram
    'WhatsApp',               // WhatsApp
    'Telegram',               // Telegram
    'Twitter',                // Twitter / X
    'Line/',                  // Line
    'Snapchat',               // Snapchat
    'WeChat', 'MicroMessenger', // WeChat
    'WebView',                // Generic Android WebView
    'wv)',                    // Android WebView indicator
  ];
  return inAppPatterns.some(p => ua.includes(p));
}

/**
 * Get the name of the in-app browser for display
 */
export function getInAppBrowserName() {
  const ua = navigator.userAgent || '';
  if (ua.includes('FBAN') || ua.includes('FBAV')) return 'Facebook';
  if (ua.includes('Instagram')) return 'Instagram';
  if (ua.includes('WhatsApp')) return 'WhatsApp';
  if (ua.includes('Telegram')) return 'Telegram';
  if (ua.includes('Twitter')) return 'Twitter/X';
  if (ua.includes('Line/')) return 'Line';
  if (ua.includes('Snapchat')) return 'Snapchat';
  if (ua.includes('WeChat') || ua.includes('MicroMessenger')) return 'WeChat';
  return 'in-app browser';
}
